import { getUserFacingDatasetName } from '@/features/datasets/utils/datasetCloneNames';

export const OriginGroupLabel = Object.freeze({
  files: 'Files',
  huggingface: 'Hugging face',
  sdk: 'SDK',
  specificAi: 'SpecificAI generated',
});

export const ORIGIN_GROUP_ORDER = Object.freeze([
  OriginGroupLabel.files,
  OriginGroupLabel.huggingface,
  OriginGroupLabel.sdk,
  OriginGroupLabel.specificAi,
]);

export function getOriginGroupLabel(origin) {
  const o = String(origin || 'unknown');
  if (o === 'specific_ai_fully_generated' || o === 'specific_ai_labeled' || o === 'specific_ai_agent') {
    return OriginGroupLabel.specificAi;
  }
  if (o === 'huggingface') return OriginGroupLabel.huggingface;
  if (o === 'sdk') return OriginGroupLabel.sdk;
  return OriginGroupLabel.files;
}

export function getOriginTooltip(origin) {
  const o = String(origin || 'unknown');
  if (o === 'specific_ai_fully_generated') return 'Fully generated by SpecificAI';
  if (o === 'specific_ai_labeled') return 'Labeled by SpecificAI';
  if (o === 'specific_ai_agent') return 'Retrieved by Dataset Retrieval Agent';

  const pretty = {
    human_created: 'Human created',
    commercial_model: 'Commercial model',
    other: 'Other',
    unknown: 'Unknown',
  }[o];
  return pretty || null;
}

export function groupOriginInfos(originInfos) {
  const list = Array.isArray(originInfos) ? originInfos : [];
  const groups = new Map(); // label -> [{name, origin}]

  for (const item of list) {
    const name = getUserFacingDatasetName((item?.name || '').trim()) || '';
    if (!name) continue;
    const origin = item?.origin ?? 'unknown';
    const label = getOriginGroupLabel(origin);
    const arr = groups.get(label) || [];
    arr.push({ name, origin });
    groups.set(label, arr);
  }

  return ORIGIN_GROUP_ORDER.filter((k) => groups.has(k)).map((k) => ({
    label: k,
    items: groups.get(k) || [],
  }));
}

